
const Valuta = function(DS) {
    return DS.defineResource({
        name: 'Valuta',
        endpoint: '/valute',
    });
};

Valuta.$inject = ['DS'];


export {Valuta};



// WEBPACK FOOTER //
// ./app/models/valuta.js